import styled from 'styled-components';

import { colors, radius } from '../../../../../../styles/tokens';

export const Container = styled.div`
  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.md};
  padding: 24px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const Subtitle = styled.p`
  font-size: 13px;
  color: ${colors.onSurfaceVariant};
  margin-top: 4px;
`;

export const Bars = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  height: 200px;
`;

export const BarColumn = styled.div`
  flex: 1;
  min-width: 0;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
`;

interface BarProps {
  height: number;
}

export const BarTrack = styled.div`
  width: 100%;
  flex: 1;

  position: relative;

  background-color: ${colors.surfaceContainer};
  border-radius: ${radius.sm};
  overflow: hidden;
`;

export const BarGlow = styled.div<BarProps>`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: ${({ height }) => height}%;
  background-color: ${colors.primary}33;
  border-radius: ${radius.sm};
  transition: height 0.5s;
`;

export const Bar = styled.div<BarProps>`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: ${({ height }) => height}%;
  background-color: ${colors.primary};
  border-radius: ${radius.sm};
  transition: height 0.5s;
`;

export const DayLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${colors.onSurfaceVariant};
`;
